import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'The field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'The field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    Notes: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    SiteName: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'required', message: 'The field is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'The field is required.' },
      ]
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Subject*',
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Your Message*',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location*',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests for Your Event*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Kings Catering Contact Form',
    formId: '439',
    clientKey: 'A1BD1EA1-BD2C-4B74-9CC1-159487C68DE0',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/kingscatering/form_structure.js